/** Figma: Day/Week cap selector — pill field + rounded menu, selected #f0f6ff + #0078a2, default #061e44 */
const MENU_SHADOW = '0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)';

export default () => ({
  root: {
    minWidth: 112,
    maxWidth: 112,
    width: 112,
    flexShrink: 0,
    display: 'inline-flex',
  },
  select: {
    borderRadius: 50,
    minHeight: 40,
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#78889c',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#78889c',
    },
    '& .MuiSelect-select': {
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 16,
      paddingRight: 32,
      display: 'flex',
      alignItems: 'center',
      color: '#333',
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  icon: {
    color: '#333',
  },
  menuPaper: {
    borderRadius: 24,
    marginTop: 4,
    maxHeight: 400,
    boxShadow: MENU_SHADOW,
    paddingTop: 8,
    paddingBottom: 8,
    border: 'none',
    overflow: 'hidden',
  },
  menuList: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  menuItem: {
    minHeight: 40,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 12,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: 0.32,
    color: '#061e44',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: 'rgba(6, 30, 68, 0.04)',
    },
    '&.Mui-selected': {
      backgroundColor: '#f0f6ff !important',
      color: '#0078a2',
      fontWeight: 700,
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#e6f0ff !important',
    },
  },
});
